var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 9.334C10.6665 9.68762 10.5258 10.0267 10.2757 10.2766C10.0255 10.5265 9.68629 10.6668 9.33267 10.6667C8.97904 10.6665 8.63998 10.5258 8.39005 10.2757C8.14013 10.0255 7.99982 9.68629 8 9.33267C8.00018 8.97904 8.14082 8.63998 8.391 8.39005C8.64117 8.14013 8.98038 7.99982 9.334 8C9.68762 8.00018 10.0267 8.14082 10.2766 8.391C10.5265 8.64117 10.6668 8.98038 10.6667 9.334ZM10.7067 11.654H8.04V20.0007H10.7067V11.654ZM14.92 11.654H12.2667V20.0007H14.8933V15.6207C14.8933 13.1807 18.0733 12.954 18.0733 15.6207V20.0007H20.7067V14.714C20.7067 10.6007 16 10.754 14.8933 12.774L14.92 11.654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedin-black.e1aeff397d645b19e5222b0bd9690211.svg";
export { ForwardRef as ReactComponent };